import { ConnectorStatusColor } from '@services/constants'
import { Device } from '@services/device'
import { IDeviceMarkerProps } from '@shared/InnmaxMap2/map.types'
import cx from 'classnames'
import { pathOr } from 'ramda'
import React from 'react'
import styled, { css } from 'styled-components'
import Marker, { IEnhanceMarkerRef } from './Marker'

const DeviceMarker = React.memo((props: IDeviceMarkerProps) => {
  const { item, focus, selected, onDelete, onDragEnd, onLeftClick, ...others } =
    props

  const markerRef = React.useRef<IEnhanceMarkerRef>(null)

  const [leftConnector, rightConnector] = React.useMemo(() => {
    if (item?.connectors?.length === 1) {
      return [item?.connectors[0], item?.connectors[0]]
    }
    if (item?.connectors?.length === 2) {
      return item?.connectors
    }
    return []
  }, [item])

  const className = cx(
    { selected: selected },
    { 'icon-animation': focus },
    'marker-wrapper'
  )

  React.useEffect(() => {
    markerRef.current?.setPosition({
      lat: item?.lat,
      lon: item?.lon,
      x: item?.x,
      y: item?.y,
    })
  }, [item])

  return Marker.Utils.isValidMarkerPosition(item) ? (
    <Marker
      {...others}
      ref={markerRef}
      tooltipContent={
        <span>{item?.displayName || item?.deviceDisplayName}</span>
      }
      onDelete={() => item && onDelete && onDelete(item)}
      onLeftClick={() => {
        item && onLeftClick && onLeftClick(item)
      }}
      defaultPosition={{
        lat: item?.lat,
        lon: item?.lon,
        x: item?.x,
        y: item?.y,
      }}
      onDragEnd={position => {
        onDragEnd &&
          onDragEnd({
            ...item,
            ...position,
          } as Device)
      }}>
      <Marker.MarkerIconDiv>
        <ChargingMarker
          leftStatus={leftConnector?.status}
          rightStatus={rightConnector?.status}
          className={className}
          css={css`
            width: 24px;
            height: 24px;
          `}>
          {/* <img
            css={css`
              padding: 3px;
            `}
            src={markerIcon(item)}
            alt={item.deviceName}
          /> */}
        </ChargingMarker>
      </Marker.MarkerIconDiv>
    </Marker>
  ) : (
    <div></div>
  )
})

export default DeviceMarker

const ChargingMarker = styled.div<{
  leftStatus?: number
  rightStatus?: number
}>`
  border: 0px !important;
  overflow: hidden;
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 50%;
    height: 120%;
    top: 0;
    left: -5%;
    z-index: 999;
    transform: rotate(135deg) scaleY(1.5);
    background-color: ${props =>
      pathOr('#fff', [props.rightStatus ?? -1], ConnectorStatusColor)};
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    left: 40%;
    top: -5px;
    width: 80%;
    height: 120%;
    transform: rotate(135deg) scaleY(1.5);
    background-color: ${props =>
      pathOr('#fff', [props.leftStatus ?? -1], ConnectorStatusColor)};
  }
`
